<!-- eslint-disable vue/require-v-for-key -->
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import { Helper, debounce } from '@/mixin/helper'
import { required } from 'vuelidate/lib/validators'
import {
  DEVICE_MUTATION_DELETE,
  DEVICE_MUTATION_UPDATE,
  GET_DEVICE_CODE,
} from '@/services/api/master/tracking'

import { GET_COMPANYS } from '@/services/api/master/companies'
import { mapGetters } from 'vuex'
import { getSmsClient } from '@/services/sms'
import * as vehicleApi from '@/services/rest-api-tools/lib/vehicle/vehicle'

const smsAxios = getSmsClient()

export default {
  page: {
    title: 'Report & Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    Multiselect,
  },

  apollo: {
    companies: {
      query: GET_COMPANYS,
    },
    deviceTypes: {
      query: GET_DEVICE_CODE,
    },
  },

  mixins: [Helper],
  props: {
    formErrors: {},
  },

  data() {
    return {
      selected: {
        tracking: [],
        listHistory: [],
        lastData: [],
        portKernel: 6000,
      },
      selectedModel: {
        tracking: [],
        listHistory: [],
        lastData: [],
      },
      allSelected: {
        tracking: false,
        listHistory: false,
        lastData: false,
      },
      indeterminate: {
        tracking: true,
        listHistory: true,
        lastData: false,
      },
      filterMonth: '',
      license_plat: null,
      vendor: null,
      tipePerangkat: null,
      filterHistory: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterRiwayat: null,
      filterOn: [],
      sortBy: 'device.imei',
      sortDesc: false,
      isEdit: false,
      set: {
        companyId: null,
        licensePlate: null,
        imei: null,
        vehicleId: null,
        note: '',
        deviceStatusId: null,
        companyName: null,
      },
      // Vehicles data
      vehicles: [],

      // Vehicle Types data
      vehicleTypes: [],

      form: {
        deviceStatusLogs: {
          imei: null,
          deviceStatusId: null,
          note: null,
        }
      },
      formOld: {
        deviceTypes: null,
        companyId: 1,
        imei: null,
        phoneNo: null,
        vehicleId: null,
      },
      show_model: null,
      show: [
        { key: 'imei', label: 'Imei' },
        { key: 'identifier', label: 'ID Pelacak' },
        { key: 'lat', label: 'Latitude' },
        { key: 'lon', label: 'Longitude' },
        { key: 'acc', label: 'Acc' },
        { key: 'speed', label: 'Speed' },
        { key: 'baterai', label: 'Baterai' },
        { key: 'date', label: 'Terakhir Update' },
        { key: 'status', label: 'Status' },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      titleModal: 'Registrasi IMEI',
      deviceTypes: {
        deviceType: [],
      },
      companies: {
        companies: [],
      },
      deviceStatusLogs: {
        deviceStatusLogs: [],
      },

      formStatus: 'create',
      status: '',
      listDeleted: [],
      filteredItems: [],
      isLoading: false,
      saveLoading: false,
      showDeviceType: false,
      vehicleYear: null,
      debounceTimer: null,
      accordionVisible: false,

      lastVehicleSearch: '',

      note: null,
      deviceStatuses: [],
      fieldMappings: {
        "x": "companyId",
        "company.companyName": "companyName",
        "company.domainName": "domainName",
        "vehicle.license_plate": "licensePlate",
        "device.imei": "imei",
        "ds.device_status_id": "deviceStatusId",
        "device_status.status": "status",
        "lds.created_at": "createdAt",
        "lds.created_by": "createdBy",
        "lds.updated_by": "updatedBy",
        "note": "note",
        "device.phoneNo": "phoneNo",
        "device.deviceType.deviceName": "deviceName",
        "created_at": "createdAt"
      },
      tableFilter: {
        deviceStatusId: [],
      },
      isDisableButton: false,
      metabaseDashboardLinks: []
    }
  },

  validations: {
    form: {
      imei: { required },
      deviceStatusId: { required },
    },
    set: {
      deviceStatusId: { required },
    },
  },

  computed: {
    title() {
      return 'Report Dan Dashboard'
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)
        return this.tracking.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.tracking
      }
    },

    tracking() {
      return [
        {
          key: 'device.imei',
          label: this.$t('qcdevice.deviceStatus.column.imei'),
          sortable: true,
        },
        {
          key: 'device.phoneNo',
          label: this.$t('qcdevice.deviceStatus.column.phoneNo'),
          sortable: true,
        },
        {
          key: 'device.deviceType.deviceName',
          label: this.$t('qcdevice.deviceStatus.column.deviceType'),
          sortable: true,
        },
        {
          key: 'company.companyName',
          label: this.$t('qcdevice.deviceStatus.column.companyName'),
          sortable: true,
        },
        {
          key: 'company.domainName',
          label: this.$t('qcdevice.deviceStatus.column.domainName'),
          sortable: true,
        },
        {
          key: 'vehicle.license_plate',
          label: this.$t('qcdevice.deviceStatus.column.licensePlate'),
          sortable: true,
        },
        {
          key: 'created_at',
          label: this.$t('qcdevice.deviceStatus.column.updatedAt'),
          sortable: true,
        },
        {
          key: 'device_status.status',
          label: this.$t('qcdevice.deviceStatus.column.latestStatus'),
          sortable: true,
        },
        {
          key: 'note',
          label: this.$t('qcdevice.deviceStatus.column.latestNote'),
          sortable: true,
        },
        {
          key: 'setCustomer',
          label: '',
          sortable: false,
        },
      ]
    },

    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),

    filteredVehicleTypes() {
      return [...this.vehicleTypes]
    },

    filteredVehicles() {
      return [...this.vehicles]
    },
  },

  async created() {
    await this.$v.set.$touch()
    this.getDeviceStatusLog()
    this.getDeviceStatuses()

    if (this.hasAccessAll("metabase-dashboard-link:read")) {
      this.getMetabaseDashboardLinks()
    }
  },

  methods: {
    async getDeviceStatuses() {
      const res = await smsAxios.get('/device-status')

      this.deviceStatuses = res.data.data
    },

    async getMetabaseDashboardLinks() {
      const res = await smsAxios.get('/metabase-dashboard-link')

      this.metabaseDashboardLinks = res.data.data
    },

    async exportDeviceStatusLogs() {
      this.isDisableButton = true
      const params = {
        page: this.currentPage,
        limit: this.perPage,
        q: this.filter,
      }

      if (this.sortBy == '') {
        this.sortBy = 'device.imei'
        this.sortDesc = true
      }

      let sortDirection = this.sortDesc ? 'desc' : 'asc'
      params.sorts = `${this.fieldMappings[this.sortBy]}:${sortDirection}`

      let filters = []

      if (this.tableFilter.deviceStatusId.length > 0) {
        const ids = this.tableFilter.deviceStatusId.map((item) => item.device_status_id)
        const idString = `${ids.join("|")}`;

        filters.push('deviceStatusId:in:' + idString)
      }

      if (filters.length > 0) {
        params.filters = filters.join(';')
      }

      const res = await smsAxios.get('/device-status-log/excel', {
        params,
        responseType: 'blob'
      }).catch((error) => {
        this.handleError(error)
      })
      if (!res) return

      const url = window.URL.createObjectURL(res.data)
      const a = document.createElement('a')
      a.href = url
      a.download = 'DeviceStatusLog.xlsx'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      this.isDisableButton = false
    },
    async getDeviceStatusLog() {
      this.isLoading = true
      const params = {
        page: this.currentPage,
        size: this.perPage,
        q: this.filter,
      }

      if (this.sortBy == '') {
        this.sortBy = 'device.imei'
        this.sortDesc = true
      }

      let sortDirection = this.sortDesc ? 'desc' : 'asc'
      params.sorts = `${this.fieldMappings[this.sortBy]}:${sortDirection}`

      let filters = []

      if (this.tableFilter.deviceStatusId.length > 0) {
        const ids = this.tableFilter.deviceStatusId.map((item) => item.device_status_id)
        const idString = `${ids.join("|")}`;

        filters.push('deviceStatusId:in:' + idString)
      }

      if (filters.length > 0) {
        params.filters = filters.join(';')
      }

      const res = await smsAxios.get('/device-status-log/recap', { params }).catch((error) => {
        this.handleError(error)
      })
      if (!res) return

      this.filteredItems = res.data.data
      this.deviceStatusLogs.deviceStatusLogs = res.data.data

      this.totalRows = res.data.total_count
      this.totalPages = res.data.total_page
      this.isLoading = false
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    addDeviceStatusLog() {
      this.isEdit = false
      this.showDeviceType = true
      this.form = {
        deviceTypes: '',
        companyId: 1,
        imei: '',
        phoneNo: '',
      }

      this.formStatus = 'create'
      this.$bvModal.show('modal-create')
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value
    },

    nextSetup(item) {
      localStorage.setItem('device', JSON.stringify(item))
      this.$router.push({
        name: 'Setting Device',
      })
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data)
      } else {
        var myIndex = this.selected[param].indexOf(data)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },

    toDelete() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_DELETE,
            variables: {
              imei: this.selected.tracking[i].imei,
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.getDeviceStatusLog()
        this.clearDelete()
        this.$toast.success(`Data berhasil dihapus`)
      })
    },

    addLog(item) {
      this.form = {
        imei: item.device.imei,
      }

      this.$bvModal.show('add-log')
    },

    async addDeviceStatusLogs() {
      this.saveLoading = true
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.saveLoading = false
        return
      }

      const payload = {
        device_status_logs: [
          {
            imei: this.form.imei,
            device_status_id: this.form.deviceStatusId.device_status_id,
            note: this.form.note,
          }
        ]
      }

      await smsAxios
        .post('/device-status-log/bulk', payload)
        .then((responAxio) => {
          this.responModal(responAxio.data)
        })
        .catch((err) => {
          this.handleError(err)
        })

      await this.getDeviceStatusLog()
      this.saveLoading = false
      this.$bvModal.hide('add-log')
    },

    responModal() {
      this.$toast.success(`Device Status Log Berhasil dibuat `)
      this.$root.$emit('bv::toggle::collapse', 'accordion-3')
      setTimeout(() => {
        if (!this.accordionVisible) {
          this.$root.$emit('bv::toggle::collapse', 'accordion-3')
        }
      }, 500)
    },

    onRowClicked(item, type) {
      item.filterBy = type

      let identifier = ''
      if (type == "imei") {
        identifier = item.device.imei
      } else if (type == "licensePlate") {
        identifier = item.vehicle?.license_plate
      } else {
        identifier = item.vehicle.id
      }

      this.$router.push({
        name: 'Device Status and History Detail',
        params: {
          identifier: identifier,
          type: type
        }
      })
    },

    clearDelete() {
      this.allSelected.tracking = false
      this.selectedModel.tracking = []
      this.selected.tracking = []
    },

    resetModal() {
      this.form = {
        vehicleId: null,
        deviceTypes: null,
        imei: null,
        phoneNo: null,
      }

      this.formStatus = 'create'
      this.accordionVisible = false
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    respModal(data) {
      this.getDeviceStatusLog()
      this.$toast.success(`IMEI "` + data.imei + `" Berhasil di daftarkan `)
      this.$root.$emit('bv::toggle::collapse', 'accordion-3')
      setTimeout(() => {
        if (!this.accordionVisible) {
          this.$root.$emit('bv::toggle::collapse', 'accordion-3')
        }
      }, 500)

      this.responseModal.vehicleId = data.vehicle_id
      this.responseModal.imei = data.imei
      this.responseModal.status = 'Register Success'
    },

    checkStatus() {
      this.responseModal.title = 'Cek Status Perangkat'
      this.$root.$emit('bv::toogle::collapse', 'accordion-3')
    },

    checkVersion() {
      this.responseModal.title = 'Cek Versi Perangkat'
      this.$root.$emit('bv::toogle::collapse', 'accordion-3')
    },

    checkLast() {
      this.responseModal.title = 'Cek Data Terakhir'
      this.$root.$emit('bv::toogle::collapse', 'accordion-3')
    },

    isDeviceCodeMatched(inputDeviceCode, ERPDeviceCode) {
      if (inputDeviceCode == ERPDeviceCode || (inputDeviceCode === 1006 && ERPDeviceCode === 1003))
        return ERPDeviceCode
    },

    async checkIMEIinERP(imei) {
      const res = await smsAxios.get(`/erp/imei-check-erp?imei=${imei}`)
      return res?.data
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.message) {
          if (errorData.message === 'license plate is already registered to another vehicle') {
            this.$toast.error(this.$t('setting.error.duplicateLicensePlate'))
            return
          }
        }

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else if (errorStatus === 409) {
          if (errorData.details) {
            errorData.details.forEach((element) => {
              this.$toast.error(`${element.message}`)
            })
          } else {
            this.$toast.error(errorData.message)
          }
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    handleSubmit() {
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create')
        this.resetModal()
      })
    },

    changeStatus(status) {
      this.status = status
      if (this.selected.tracking.length > 0) {
        this.showModal = true
      } else {
        this.$toast.error(`Minimal memilih satu atau lebih dari data di bawah.`)
      }
    },

    toChangeStatus() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_UPDATE,
            variables: {
              input: {
                imei: this.selected.tracking[i].imei,
                status: this.status == 'Aktif' ? 0 : 2,
              },
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$toast.success(`Berhasil mengubah ${this.selected.tracking.length} status pelacak.`)
        this.showModal = false
        this.getDeviceStatusLog()
        this.clearDelete()
      })
    },

    customLabel(item) {
      return `${item.name} (${item.domainName})`
    },

    customLabelDevice(item) {
      if (item.deviceName) return `${item.deviceName}`
    },

    showDeviceTypes() {
      this.showDeviceType = true
      const interval = setInterval(() => {
        this.$refs.deviceTypeRef.isOpen = true
        if (this.$refs.deviceTypeRef) clearInterval(interval)
      }, 100)
    },

    changePage(newPage) {
      this.currentPage = newPage
      this.getDeviceStatusLog()
    },

    onChangeFilterStatus() {
      this.getDeviceStatusLog()
    },

    resetFilter(e) {
      this.currentPage = 1
      this.perPage = e
      this.getDeviceStatusLog()
    },

    searchData: debounce(function () {
      this.getDeviceStatusLog()
    }, 600),

    onImeiChange(e) {
      let self = this
      clearTimeout(self.debounceTimer)
      self.debounceTimer = setTimeout(async () => {
        const IMEIFromERP = await this.checkIMEIinERP(e)
        if (IMEIFromERP?.device_code) {
          const deviceName = this.deviceTypes?.deviceType.find(
            (e) => e.deviceCode == IMEIFromERP.device_code
          ).deviceName
          this.form.deviceTypes = {
            deviceCode: IMEIFromERP.device_code,
            deviceName: deviceName ?? IMEIFromERP.device_name,
          }
        } else {
          this.form.deviceTypes = null
        }
      }, 300)
    },

    async addVehicleTag(newValue) {
      const tag = {
        license_plate: newValue,
        vehicle_id: this.set.vehicleId,
        vehicle_type_id: 0,
        odometer: this.set.odometer,
      }
      this.set.selectedVehicle = tag
      this.vehicles.push(tag)
      const params = {
        filters: [`company_id eq 1`],
        limit: 1,
      }
      const responseLimit1 = await vehicleApi.getVehicleType(params)
      const totalCount = responseLimit1.metadata.total_count
      params.limit = totalCount
      const response = await vehicleApi.getVehicleType(params)
      const vehicleTypes = response.data.paginated_result
      this.vehicleTypes = vehicleTypes
    },

    formatNote(item) {
      if (!item?.note) return ""

      if (item.note.includes("Dilakukan Oleh")) {
        item.note = item.note.replace("Dilakukan Oleh", "").trim()
      }

      return item.note
    },

    handleFailedValidation() {
      return
    },

    sortingChanged(ctx) {
      if (ctx.sortBy == '') {
        return
      }

      this.sortDesc = ctx.sortDesc
      this.sortBy = ctx.sortBy

      this.getDeviceStatusLog()
    },
  },
}
</script>

<style>
.formulate-input ul.formulate-input-errors {
  font-style: normal;
  font-size: 80%;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" />
    <p class="mb-4">Status WO perangkat, custom report dan dashboard</p>
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button @click="$router.push({ name: 'Device Status' })" variant="outline-primary"
          menu-class="dropdown-menu-end" class="ms-3">
          <i class="mc-fa icon-outline_settings"></i> Pengaturan
        </b-button>
      </div>
    </div>

    <div class="row mb-3" v-if="hasAccessAll('device-status-log:read') || hasAccessAll('metabase-dashboard-link:read')">
    </div>
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">{{ "Status Perangkat" }}</span>
            </template>
            <div class="clearfix">
              <div class="float-start w-25">
                <multiselect v-model="tableFilter.deviceStatusId" :options="deviceStatuses" :multiple="true"
                  :close-on-select="false" :clear-on-select="false" :preserve-search="true" :hide-selected="true"
                  :allow-empty="true" placeholder="Select status" label="status" track-by="device_status_id"
                  @input="onChangeFilterStatus" />
              </div>

              <!-- Search -->
              <div class="float-end">
                <div class="mc-table-view">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                        class="ms-2 form-control" @input="searchData"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <!-- End search -->

              <div class="float-end d-flex gap-2">
                <b-button v-if="hasAccessAll('device-status-log:read')" variant="primary" type="button"
                  @click="exportDeviceStatusLogs"
                  :disabled="!(deviceStatusLogs.deviceStatusLogs.length > 0) || isLoading || isDisableButton">
                  <b-spinner v-if="isLoading" small type="grow"></b-spinner>
                  {{ this.$t('global.export') }}
                </b-button>
                <div class="mc-table-filter" v-if="hasAccessAll('device-status-log:create')">
                  <a class="popup-form btn btn-primary" href="javascript: void(0);" variant="secondary"
                    icon="icon-outline_upload" @click="$router.push({ name: 'Create Device Status Log' })">
                    <i class="bx bx-plus"></i> {{ $t('global.addField') }}
                  </a>
                </div>
              </div>
            </div>

            <div class="table-responsive my-3 border border-1">
              <b-table class="datatables" :items="deviceStatusLogs.deviceStatusLogs" :fields="visibleFields" show-empty
                :empty-text="$t('global.emptyTable')" :empty-filtered-text="$t('global.emptyFilteredTable')"
                :per-page="perPage" @sort-changed="sortingChanged" @filtered="onFiltered" :busy="isLoading"
                @hidden="resetModal" :no-local-sorting="true">
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(device.imei)="data">
                  <strong class="text-primary" @click="onRowClicked(data.item, 'imei')">
                    {{ data.item.device.imei }}
                  </strong>
                </template>
                <template #cell(vehicle.license_plate)="data">
                  <strong class="text-primary" @click="onRowClicked(data.item, 'licensePlate')">
                    {{ data.item.vehicle.license_plate }}
                  </strong>
                </template>
                <template #cell(device_status.status)="data">
                  <strong :style="{
                    color: data.item.device_status.status === 'Normal' ? 'green' :
                      data.item.device_status.status === 'Maintenance' ? 'orange' :
                        data.item.device_status.status === 'Need to Check' ? 'red' :
                          data.item.device_status.status === 'Testing' ? 'blue' : 'black'
                  }">
                    {{ data.item.device_status.status }}
                  </strong>
                </template>
                <template #cell(created_at)="data">
                  {{ data.item.created_at == "0001-01-01T00:00:00Z" ? "" : momentDMHms(data.item.created_at) }}
                </template>
                <template #cell(note)="data">
                  {{ formatNote(data.item) }}
                </template>
                <template #cell(setCustomer)="data">
                  <div class="button-items" style="text-align: center">
                    <b-button v-if="hasAccessAll('device-status-log:create')" id="tooltip-set-to" :class="getAccessRight('qcDevice') ||
                      hasAccessAll(['device-status-log:update', 'device-status-log:read'])
                      " variant="me-3 btn-outline-primary" @click="addLog(data.item)">
                      Add Log
                    </b-button>
                    <b-tooltip target="tooltip-set-to" placement="top" title="Tambah Log">
                    </b-tooltip>
                  </div>
                </template>
              </b-table>
            </div>

            <div class="row mt-10">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <span>Menampilkan</span>
                    <span>
                      <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                        :options="pageOptions" @change="resetFilter" />
                    </span>
                    <span>entri.&nbsp;&nbsp;</span>
                    <span>Menampilkan&nbsp;
                      <strong>
                        {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                      </strong>
                      &nbsp;sampai&nbsp;
                      <strong>
                        {{
                          currentPage != totalPages
                            ? currentPage * perPage
                            : (currentPage - 1) * perPage + filteredItems.length
                        }}
                      </strong>
                      &nbsp;dari&nbsp;
                      <strong>{{ totalRows }}</strong>
                      &nbsp;entri.
                    </span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                      @change="changePage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </b-tab>
          <div v-for="(mdl, index) in metabaseDashboardLinks" :key="index">
            <b-tab v-if="hasAccessAll([`${mdl.access_name}:read`])" class="border-0">
              <template v-slot:title>
                <span class="d-none d-sm-inline-block">{{ mdl.dashboard_name }}</span>
              </template>

              <iframe :src="mdl.dashboard_link" frameborder="0" width="100%" height="1600px" allowfullscreen />
            </b-tab>
          </div>
        </b-tabs>
      </div>
    </div>

    <!-- Create -->
    <b-modal id="add-log" ref="add-log" size="lg" title="Tambah Status" @hidden="resetModal" centered>
      <b-row>
        <!-- IMEI -->
        <b-col md="3">
          <div class="mb-3">
            <span class="d-block">IMEI</span>
            <strong>{{ form.imei }}</strong>
          </div>
        </b-col>
      </b-row>
      <FormulateForm v-model="form" :errors="formErrors" @failed-validation="handleFailedValidation">
        <div class="mb-2">
          <label class="required">{{ $t('qcdevice.deviceStatus.selectStatus') }}</label>
          <multiselect v-model="form.deviceStatusId" :options="deviceStatuses" placeholder="Pilih Status" label="status"
            :class="{
              'is-invalid': $v.form.deviceStatusId.$error,
            }" />
          <div v-if="$v.form.deviceStatusId.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.form.deviceStatusId.required">
              Status Wajib Terisi
            </span>
          </div>
        </div>

        <b-form-group label="Note" label-for="note" class="mb-3">
          <b-form-textarea v-model="form.note" id="note" placeholder="Masukkan catatan" rows="6"
            :disabled="isLoading" />
        </b-form-group>
      </FormulateForm>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav"> </b-col>
          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <b-button :disabled="saveLoading" variant="outline-primary" @click="cancel" class="me-3"> Batal </b-button>
            <b-button :disabled="saveLoading" type="submit" variant="primary" @click="addDeviceStatusLogs">
              <b-spinner v-if="saveLoading" small />
              Simpan
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
